import axios from "../utils/axios";

class AssetInventoryService
{
assetInventory(params)
{
    return axios.get("assetInventoryReport", {params});
}
assetInventoryALL(params)
{
    return axios.get("assetInventoryReport/ALL", {params});
}
lists(params){
    return axios.get("assets", {params});
}
 
lists50summary(params) {
    return axios.get('asset/lists50summary', { params });
}
lists1(params){
    return axios.get("assets1", {params});
}
lists4(params){
    return axios.get("assets4", {params});
}

lists7(params){
    return axios.get("assets7", {params});
}

lists8(params){
    return axios.get("assets8", {params});
}

lists9(params){
    return axios.get("assets9", {params});
}
lists10(params){
    return axios.get("assets10", {params});
}
lists10sub(params){
    return axios.get("assets10sub", {params});
}

lists50(params){
    return axios.get("assets50", {params});
}
lists50sub(params){
    return axios.get("assets50sub", {params});
}
all(params){
    return axios.get("assets/ALL", {params});
}
all(params){
    return axios.get("assets1/ALL", {params});
}
}

export default new AssetInventoryService();